import { SamlAuthRequiredError } from '@/lib/errors'
import { useIdCompany, useSamlSession } from '@/lib/hooks'

export const SamlSessionGuard = () => {
  const { idCompany } = useIdCompany()
  const { samlRestrictedCompanies, hasActiveSamlSession } = useSamlSession()

  const samlCompany = samlRestrictedCompanies.find((c) => c.id === idCompany)
  if (samlCompany && !hasActiveSamlSession(samlCompany.id)) {
    throw new SamlAuthRequiredError(samlCompany.id, samlCompany.companyName)
  }

  return null
}
